import React, { Component } from "react";
import {
  Grid,
  Icon,
  Button,
  Divider,
  Dropdown,
  Label,
  Form
} from "semantic-ui-react";
import "./custinfo.css";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
// import { log } from "util";

class PmInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      dlist: [],
      editing: false,
      editvalue: {},
      deletevalue: [],
      deletelist: [],
      editinfo: {},
      nextdate: null,
      lastdate: null,
      newitem: false
    };
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.pmitems !== undefined && this.state.list.length === 0) {
      this.genpms();
    }
  }
  componentDidMount() {
    if (
      this.props.pmitems !== undefined &&
      this.state.list.length === 0 &&
      this.props.wods.length
    ) {
      console.log(this.props.pmitems);
      this.genpms();
      this.getNextDefNumber();
    }
    this.setState({ nextdate: moment(), lastdate: moment() });
  }
  genpms() {
    let lst = this.state.list;
    let Dlist = this.state.dlist;
    this.props.pmitems.map(item => {
      let itemtext = item.contactname + " - " + item.custname;
      let newitem = {
        key: item.defnumber,
        value: item,
        text: itemtext
      };

      lst.push(newitem);
      if (
        this.props.wods.findIndex(
          wod => wod.contactName == item.contactname
        ) === -1
      ) {
        Dlist.push(newitem);
      }
    });
    var defnumbers = this.props.pmitems.map(pm => pm.defnumber);
    this.setState({ list: lst, dlist: Dlist, defnumbers });
  }
  handlesave() {
    var nexteditvalue = this.state.editvalue;
    if (this.state.editvalue.nextcontactdate !== null) {
      nexteditvalue.nextcontactdate = moment(
        this.state.editvalue.nextcontactdate
      ).format("MM/DD/YYYY");
    }
    if (this.state.editvalue.lastcontactdate !== null) {
      nexteditvalue.lastcontactdate = moment(
        this.state.editvalue.lastcontactdate
      ).format("MM/DD/YYYY");
    }
    if (this.state.newentry) {
      this.props
        .create(nexteditvalue)
        .then(res => this.setState({ newentry: false, editvalue: res }));
    }

    this.props.handleupdateitems(
      nexteditvalue,
      nexteditvalue.defnumber,
      "engassigned"
    );
  }
  handledelete() {
    var deletepayload = [];
    this.state.deletevalue.map(dl => {
      let newtitle = dl.custname + " - " + dl.contactname;
      let newitem = {
        title: newtitle,
        id: dl.defnumber
      };
      deletepayload.push(newitem);
    });
    console.log("Delete Payload", deletepayload);
    this.props.handleDelete(deletepayload, "engassigned");
    this.setState({ deletevalue: [] });
  }
  gendefnumInput() {
    if (this.state.newentry) {
      return (
        <Form.Input
          value={this.state.editvalue.defnumber}
          error={
            this.state.defnumbers.includes(this.state.editvalue.defnumber) ||
            !parseInt(this.state.editvalue.defnumber)
          }
          label="Def Number:"
          onKeyPress={e => {
            console.log(e.key);
            if (!parseInt(e.key) && e.key != 0) {
              e.preventDefault();
            }
          }}
          onChange={e => {
            this.setState({
              editvalue: {
                ...this.state.editvalue,
                defnumber: e.target.value
              }
            });
          }}
        />
      );
    } else {
      return (
        <Label size="large">
          Def Number:
          {"  " + this.state.editvalue ? this.state.editvalue.defnumber : ""}
        </Label>
      );
    }
  }
  geneditform() {
    let pm = Object.assign({}, this.state.editvalue);
    if (pm.lastcontactdate !== null) {
      console.log(pm.lastcontactdate);
      pm.lastcontactdate = moment(pm.lastcontactdate);
    }
    if (pm.nextcontactdate !== null) {
      pm.nextcontactdate = moment(pm.nextcontactdate);
    }
    var customer = this.props.customers.find(
      cust => cust.value.custnumber === pm.custnumber
    );

    console.log(customer ? customer.value : "");

    var formtitle = this.state.newentry ? "Add Project Manager" : "Edit:";

    if (this.state.editing !== false) {
      return (
        <div>
          <Grid>
            <Grid.Column width={2}>
              <h3>{formtitle}</h3>
            </Grid.Column>
            <Grid.Column width={4}>
              <h4>
                {pm.contactname} ({pm.custname})
              </h4>
            </Grid.Column>

            <Grid.Column width={3}>
              <Button
                id="billingsavebtn"
                disabled={
                  !parseInt(pm.defnumber) ||
                  !pm.custnumber ||
                  !pm.custname.length ||
                  !pm.contactname.length ||
                  !pm.contactemail.length
                }
                color={this.state.newentry ? "blue" : "green"}
                onClick={() => this.handlesave()}
              >
                {this.state.newentry ? "Create PM" : "Save"}
              </Button>
              <Button
                id="billingsavebtn"
                onClick={() => this.setState({ editing: false })}
              >
                Cancel
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />
          <Form>
            <Grid>
              <Grid.Column width={2}>{this.gendefnumInput()}</Grid.Column>
              <Grid.Column width={8}>
                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Project Manager Name"
                    value={pm.contactname}
                    onChange={e => {
                      pm.contactname = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Field>
                    <Label>Company</Label>
                    <Dropdown
                      placeholder="Assigned Company"
                      search
                      selection
                      options={this.props.customers}
                      value={customer ? customer.value : null}
                      onChange={(e, { value }) => {
                        this.setState({
                          editvalue: {
                            ...this.state.editvalue,
                            custname: value.custname,
                            custnumber: value.custnumber
                          }
                        });
                      }}
                    />
                  </Form.Field>
                </Form.Group>

                <Form.Group>
                  <Form.Input
                    width={16}
                    label="Project Manager Phone"
                    value={pm.custphone}
                    onChange={e => {
                      pm.custphone = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={6}
                    label="Project Manager Email"
                    value={pm.contactemail}
                    onChange={e => {
                      pm.contactemail = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                  <Form.Input
                    width={6}
                    label="Invoice CC Email"
                    value={pm.invccemail}
                    onChange={e => {
                      pm.invccemail = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="Address"
                    value={pm.contactaddress}
                    onChange={e => {
                      pm.contactaddress = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                  <Form.TextArea
                    width={8}
                    label="Comments"
                    value={pm.custcomment}
                    onChange={e => {
                      pm.custcomment = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Field width={6}>
                    <Label>Last Date Of Contact</Label>
                    <DatePicker
                      selected={pm.lastcontactdate}
                      onChange={date => {
                        pm.lastcontactdate = date;
                        this.setState({ editvalue: pm });
                      }}
                      maxDate={moment()}
                    />
                  </Form.Field>
                  <Form.Field width={6}>
                    <Label>Next Date Of Contact</Label>
                    <DatePicker
                      minDate={moment()}
                      selected={pm.nextcontactdate}
                      onChange={date => {
                        pm.nextcontactdate = date;
                        this.setState({ editvalue: pm });
                      }}
                    />
                  </Form.Field>
                </Form.Group>
                <Form.Group>
                  <Form.Input
                    width={8}
                    label="Username"
                    value={pm.userid}
                    onChange={e => {
                      pm.userid = e.target.value;
                      this.setState({ editvalue: pm });
                    }}
                  />
                  <Form.Button
                    width={4}
                    id="deletecontactbutton"
                    onClick={() => {
                      this.props.handledelete();
                    }}
                  >
                    Reset Password
                  </Form.Button>
                </Form.Group>
              </Grid.Column>
            </Grid>
          </Form>
        </div>
      );
    }
  }
  getNextDefNumber() {
    var new_def = 0;
    this.props.pmitems.forEach(pm => {
      let def = parseInt(pm.defnumber);
      console.log("DEF " + def);

      if (def > new_def) {
        new_def = def + 1;
      }
    });
    console.log("NeW Def " + new_def);

    this.setState({ new_def });
  }
  render() {
    if (this.props.pmitems) {
      var newpm = {
        custname: "",
        custnumber: "",
        contactname: "",
        contactemail: "",
        contactaddress: "",
        invccemail: "",
        custphone: "",
        custcomment: "",
        lastcontactdate: null,
        nextcontactdate: null,
        userid: ""
      };
      return (
        <div className="PmInfo">
          <Grid>
            <Grid.Column width={5}>
              <Label>Select Project Manager to Edit</Label>

              <Dropdown
                placeholder="Project Managers"
                fluid
                search
                selection
                options={this.state.list}
                onChange={(e, { value }) => {
                  this.setState(
                    {
                      editvalue: value,
                      editing: true,
                      newentry: false
                    },
                    () => console.log(this.state.editvalue)
                  );
                }}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Button
                color="blue"
                id="deletecontactbutton"
                disabled={!this.state.new_def}
                onClick={() =>
                  this.setState({
                    newentry: true,
                    newitem: true,
                    editing: true,
                    editvalue: { ...newpm, defnumber: this.state.new_def }
                  })
                }
              >
                <Icon name="plus" /> PM
              </Button>
            </Grid.Column>
            <Grid.Column width={6}>
              <Label>Select Project Managers to Delete</Label>
              <Dropdown
                placeholder="Select Project Managers to Delete"
                fluid
                search
                selection
                multiple
                value={this.state.deletevalue}
                options={this.state.dlist}
                onChange={(e, { value }) => {
                  this.setState({ deletevalue: value });
                }}
              />
            </Grid.Column>
            <Grid.Column width={1}>
              <Button
                negative
                id="deletecontactbutton"
                onClick={() => this.handledelete()}
              >
                Delete
              </Button>
            </Grid.Column>
          </Grid>
          <Divider />

          {this.geneditform()}
        </div>
      );
    } else {
      return <h3>Loading ...</h3>;
    }
  }
}
export default PmInfo;



// WEBPACK FOOTER //
// ./src/components/customerinfo/pm.js